module.exports = __webpack_public_path__ + "img/dark.c5436984.svg";